import { env } from 'core/config/environment';
import { useEffect } from 'react';

export const useFacebookInit = () => {
  useEffect(() => {
    window.FB.init({
      appId: env.META_APP_ID,
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v21.0'
    });
  }, []);
};
